import { push, replace } from 'react-router-redux';
import { currentClassRoomId } from '../../selectors/classroom';

const selectGroupSet = (groupSetId) => (dispatch, getState) => {
  const state = getState();
  const currentPathname = state.routing.locationBeforeTransitions.pathname;
  const queryParams = state.routing.locationBeforeTransitions.query;
  const classRoomId = currentClassRoomId(state);
  const groupsPathPrefix = `/dashboard/${classRoomId}/people/groups`;
  let url = `/dashboard/${classRoomId}/people/groups/${groupSetId}`;

  // Append the queryparams if available
  if (queryParams && Object.keys(queryParams).length > 0) {
    const searchParams = new URLSearchParams(queryParams);
    url = `${url}?${searchParams.toString()}`;
  }

  if (currentPathname === groupsPathPrefix) {
    dispatch(replace(url));
  } else if (currentPathname.startsWith(groupsPathPrefix)) {
    dispatch(push(url));
  }
};

export default selectGroupSet;
